module.exports = __webpack_public_path__ + "img/logo_spex.73581f36.png";